export const siteMock = {
  "domain": "nowhiring.com/demo",
  "jobSearchCriteria": [],
  "owner": {
    "id": "318502",
    "type": "tms-customer"
  },
  "settings": {
    "homepageUrl": "http://www.snagajob.com/about/",
    "name": "The Good Shop",
    "hideFooter": false,
    "excludeFromSiteMap": false
  },
  "contactInfo": {
    "phoneInfo": {
      "html": "<p class=\"ql-align-center\"><span style=\"color: rgb(255, 255, 255);\">508-335-9867</span></p>",
      "placeholder": null
    },
    "emailInfo": {
      "html": "<p class=\"ql-align-center\"><span style=\"color: rgb(255, 255, 255);\">robert.lavoie@snagajob.com</span></p>",
      "placeholder": null
    }
  },
  "footer": {
    "sections": [
      {
        "isReadOnly": false,
        "backgroundImage": null,
        "columns": [
          {
            "type": "text",
            "html": "<p class=\"ql-align-center\"><span style=\"color: rgb(255, 255, 255);\">508-335-9867</span></p><br><p class=\"ql-align-center\"><span style=\"color: rgb(255, 255, 255);\">robert.lavoie@snagajob.com</span></p>",
            "image": null,
            "videoUrl": null
          }
        ],
        "header": null,
        "type": "content"
      }
    ]
  },
  "id": "079e2325fdf84dd08c449653e23f9c94",
  "navigation": [
    {
      "name": "home",
      "page": "home"
    }
  ],
  "pages": [
    {
      "name": "home",
      "sections": [
        {
          "isReadOnly": false,
          "backgroundImage": null,
          "columns": [
            {
              "type": "text",
              "html": "<h3><span style=\"color: rgb(0, 130, 194);\">Company Overview</span></h3><p>The Good Company is based in Charleston, South Carolina and we’re on a mission to bring you the best every day. We were founded on the principles of high quality products and great customer service. We believe you can have fun and still make a difference. Its what we built our culture around and why we’re so great at what we do.</p>",
              "image": null,
              "videoUrl": null
            },
            {
              "type": "image",
              "html": null,
              "image": {
                "url": "/assets/images/the-good-company/tgc-company-overview.png",
                "altText": null
              },
              "videoUrl": null
            }
          ],
          "header": {
            "type": null,
            "html": null,
            "image": null,
            "videoUrl": null
          },
          "type": "content"
        },
        {
          "isReadOnly": false,
          "backgroundImage": null,
          "columns": [
            {
              "type": "image",
              "html": null,
              "image": {
                "url": "/assets/images/the-good-company/tgc-company-benefits.png",
                "altText": null
              },
              "videoUrl": null
            },
            {
              "type": "text",
              "html": "<h3><span style=\"color: rgb(0, 130, 194);\">Company Benefits</span></h3><p>The good company offers a wide variety of employee benefits raging from: Health Care Insurance, Disability Insurance, Life Insurance, Retirement / Pension Plans, Flexible Compensation, and Paid Leave.</p><p>We are also family focused so we work with you to provide you with a schedule that brings the best out of your character at work and at home.</p>",
              "image": null,
              "videoUrl": null
            }
          ],
          "header": {
            "type": null,
            "html": null,
            "image": null,
            "videoUrl": null
          },
          "type": "content"
        },
        {
          "isReadOnly": false,
          "backgroundImage": null,
          "columns": [
            {
              "type": "text",
              "html": "<h3><span style=\"color: rgb(0, 130, 194);\">Company Culture</span></h3><p>The Good Company is filled with energetic, creative, positive, hardworking, team members who bring out the best in each other day in and day out. We have fun, we work hard, and we celebrate each other’s successes. If that sounds like you or someone you know, click the link below… we’re always looking for the best of the best/p>",
              "image": null,
              "videoUrl": null
            },
            {
              "type": "image",
              "html": null,
              "image": {
                "url": "/assets/images/the-good-company/tgc-company-culture.png",
                "altText": null
              },
              "videoUrl": null
            }
          ],
          "header": {
            "type": null,
            "html": null,
            "image": null,
            "videoUrl": null
          },
          "type": "content"
        },
        {
          "isReadOnly": false,
          "backgroundImage": null,
          "columns": [
            {
              "type": "text",
              "html": "<h3 class=\"ql-align-center\"><span style=\"color: rgb(0, 130, 194);\">Colin Achiova</span></h3><p>You are passionate, articulate & knowledgeable about food & drink and you bring previous experience. You are contagiously friendly with a professional polish that we enhance with dedicated traini to enable you to be the best you can be and earn an exceptional income.</p>",
              "image": {
                "url": "/assets/images/the-good-company/tgc-employee1.png",
                "altText": null
              },
              "videoUrl": null
            },
            {
              "type": "text",
              "html": "<h3 class=\"ql-align-center\"><span style=\"color: rgb(0, 130, 194);\">Jessica Suthers</span></h3><p>You are passionate, articulate & knowledgeable about food & drink and you bring previous experience. You are contagiously friendly with a professional polish that we enhance with dedicated traing to enable you to be the best you can be and earn an exceptional income.</p>",
              "image": {
                "url": "/assets/images/the-good-company/tgc-employee3.png",
                "altText": null
              },
              "videoUrl": null
            },
            {
              "type": "text",
              "html": "<h3 class=\"ql-align-center\"><span style=\"color: rgb(0, 130, 194);\">Katy Inogri</span></h3><p>You are passionate, articulate & knowledgeable about food & drink and you bring previous experience. You are contagiously friendly with a professional polish that we enhance with dedicated trainingo enable you to be the best you can be and earn an exceptional income.</p>",
              "image": {
                "url": "/assets/images/the-good-company/tgc-employee2.png",
                "altText": null
              },
              "videoUrl": null
            }
          ],
          "header": {
            "type": "text",
            "html": "<h3 class=\"ql-align-center\"><span style=\"color: rgb(0, 130, 194);\">Team Bios</span></h3>",
            "image": null,
            "videoUrl": null
          },
          "type": "content"
        },
        {
          "isReadOnly": false,
          "backgroundImage": {
            "url": "/assets/images/the-good-company/tgc-testimonial-bg.png",
            "altText": null
          },
          "columns": [
            {
              "type": "testimonial",
              "html": "<h3 class=\"ql-align-center\"><span style=\"color: rgb(255, 255, 255);\">\"I’ve had the most awesome time at this job since I started in September. I love my co-workers and the extra cash I get to spend\"</span></h3><p><br></p><p class=\"ql-align-center\"><span style=\"color: rgb(255, 255, 255);\">-Bobby</span></p>",
              "image": null,
              "videoUrl": null
            }
          ],
          "header": {
            "type": null,
            "html": null,
            "image": null,
            "videoUrl": null
          },
          "type": "content"
        },
        {
          "isReadOnly": false,
          "backgroundImage": null,
          "columns": [],
          "header": null,
          "type": "job-search"
        }
      ]
    },
    {
      "name": "about",
      "sections": [
        {
          "isReadOnly": false,
          "backgroundImage": null,
          "columns": [
            {
              "type": "text",
              "html": "<h3><span style=\"color: rgb(0, 130, 194);\">About Us</span></h3><p>The Good Company is based in Charleston, South Carolina and we’re on a mission to bring you the best every day. We were founded on the principles of high quality products and great customer service. We believe you can have fun and still make a difference. Its what we built our culture around and why we’re so great at what we do.</p>",
              "image": null,
              "videoUrl": null
            }
          ],
          "header": {
            "type": null,
            "html": null,
            "image": null,
            "videoUrl": null
          },
          "type": "content"
        },
        {
          "isReadOnly": false,
          "backgroundImage": null,
          "columns": [
            {
              "type": "image",
              "html": null,
              "image": {
                "url": "/assets/images/the-good-company/tgc-company-benefits.png",
                "altText": null
              },
              "videoUrl": null
            },
            {
              "type": "text",
              "html": "<h3><span style=\"color: rgb(0, 130, 194);\">Company Benefits</span></h3><p>The good company offers a wide variety of employee benefits raging from: Health Care Insurance, Disability Insurance, Life Insurance, Retirement / Pension Plans, Flexible Compensation, and Paid Leave.</p><p>We are also family focused so we work with you to provide you with a schedule that brings the best out of your charact at work and at home.</p>",
              "image": null,
              "videoUrl": null
            }
          ],
          "header": {
            "type": null,
            "html": null,
            "image": null,
            "videoUrl": null
          },
          "type": "content"
        },
        {
          "isReadOnly": false,
          "backgroundImage": null,
          "columns": [
            {
              "type": "text",
              "html": "<h3><span style=\"color: rgb(0, 130, 194);\">Company Culture</span></h3><p>The Good Company is filled with energetic, creative, positive, hardworking, team members who bring out the best in each other day in and day out. We have fun, we work hard, and we celebrate each other’s successes. If that sounds like you or someone you know, click the link below… we’re always looking for the best of the best/p>",
              "image": null,
              "videoUrl": null
            },
            {
              "type": "image",
              "html": null,
              "image": {
                "url": "/assets/images/the-good-company/tgc-company-culture.png",
                "altText": null
              },
              "videoUrl": null
            }
          ],
          "header": {
            "type": null,
            "html": null,
            "image": null,
            "videoUrl": null
          },
          "type": "content"
        },
        {
          "isReadOnly": false,
          "backgroundImage": null,
          "columns": [],
          "header": null,
          "type": "job-search"
        }
      ]
    }
  ],
  "siteIntro": {
    "backgroundImage": {
      "url": "/assets/images/the-good-company/tgc-header-bg.png",
      "altText": null
    },
    "html": "<h2 class=\"ql-align-center\"><span style=\"color: rgb(255, 255, 255);\">Careers</span></h2>"
  },
  "socialMedia": {
    "facebook": {
      "link": "http://www.facebook.com"
    },
    "instagram": {
      "link": "http://www.instagram.com"
    },
    "linkedin": {
      "link": "http://www.linkedin.com"
    },
    "twitter": {
      "link": "http://www.twitter.com"
    },
    "youtube": {
      "link": "http://www.youtube.com"
    }
  },
  "theme": {
    "buttonColor": null,
    "color": "#0082C2",
    "font": "Open Sans",
    "headerFont": "Open Sans",
    "logo": {
      "url": "/assets/images/the-good-company/tgc-logo.png",
      "altText": null
    },
    "logoPosition": null
  }
}